var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "backer-center-section",
    {
      attrs: {
        title: _vm.Resources.BackerCenter.SectionPledgesAndOrdersHeader,
        "link-more": _vm.linkMore,
        "label-more": _vm.Resources.BackerCenter.ViewAllPledgesOrdersLabel,
        "is-loading": _vm.isProcessing,
        "is-empty": !_vm.hasPledges,
        "empty-title":
          _vm.Resources.BackerCenter.PledgesAndOrdersEmptyStateHeader,
        "empty-description":
          _vm.Resources.BackerCenter.PledgesAndOrdersEmptyStateParagraph,
        "data-qa": "your-dashboard-pledges-and-orders",
      },
    },
    _vm._l(_vm.mappedPledges, function (pledge) {
      return _c(
        "backer-center-pledges-preview",
        _vm._b(
          { key: pledge.orderID },
          "backer-center-pledges-preview",
          pledge,
          false
        )
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }